<template>
  <div id="InformacionCedula_div">
    <h5>{{titulo}}</h5>
    <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
    <div class="form-group info" id="Folio_div">
      <h6>Folio</h6>
      <input class="form-control" type="text" placeholder="######" v-model="cedula.CedulaId" disabled />
    </div>
    <div class="form-group info tooltip-ps-cedula" id="Juzgado_div">
      <h6>Juzgado</h6>
      <input class="form-control" type="text" v-model="juzgado" readonly v-tooltip:right="juzgado" />
    </div>
    <div class="form-group info" id="TipoDocumento_div">
      <h6>Tipo de Documento</h6>
      <input class="form-control" type="text" v-model="tipoDeDocumento" disabled />
    </div>
    <div class="form-group info" id="Consecutivo_div">
      <h6>Número de documento</h6>
      <input class="form-control" type="text" v-model="numeroDocumento" disabled />
    </div>
    <div class="form-group info" id="TipoCedula_div">
      <h6>Tipo de cédula</h6>
      <input class="form-control" type="text" v-model="cedula.TipoCedula.Nombre" disabled />
    </div>
    <div v-if="!esConsultaPublica" class="form-group info" id="Estatus_div">
      <h6>Estatus</h6>
      <input class="form-control" type="text" v-model="cedula.Estatus.Nombre" disabled />
    </div>
    <div v-if="mostrarMotivos" class="form-group info" id="Estatus_div">
      <h6>Motivos de regreso</h6>
      <textarea disabled v-model="motivosDeRegreso" type="text" rows="5" class="form-control"/>
    </div>
    <div v-if="!esConsultaPublica" class="form-group info" id="Resultado_div">
      <h6>Resultado</h6>
      <input class="form-control" type="text" v-model="resultado" disabled />
    </div>
    <div v-if="mostrarObservacionesAbogado" class="form-group info" id="ObservacionesAbogado_div">
      <!-- <h6>Observaciones por parte de abogado</h6>
      <textarea cols="3" class="form-control" v-model="cedula.ObservacionesAbogado" disabled></textarea> -->
      <h6>Observaciones de abogados</h6>
      <hr />
      <div v-if="observacionesDeAbogado.length < 1" class="contenedor-observaciones">
          <h6 class="text-center">Sin observaciones</h6>
      </div>
      <div id="contenedor-observacion">
          <div v-for="(observacion,index) in observacionesDeAbogado" class="form-group" :key="index">
              <h6>[{{obtenerNombreCompleto(observacion)}}]</h6>
              <textarea disabled v-model="observacion.Observaciones" type="text" rows="5" class="form-control"/>
          </div>
      </div>
    </div>
    <!-- <div class="form-group info" id="ObservacionesResultado_div">
      <h6>Observaciones de resultado</h6>
      <textarea cols="3" class="form-control" v-model="cedula.ObservacionesResultado" disabled></textarea>
    </div>   -->  
  </div>
</template>
<script>
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

  export default {
    directives: {
      tooltipF
    },
    data() {
      return {
        observacionesDeAbogado: [],
        resultado: 'Sin resultado',
        tipoDeDocumento: null,
        numeroDocumento: null,
        juzgado: 'Sin juzgado',
        motivosDeRegreso: 'No se especificaron los motivos',
        ESTATUS_CEDULA_REGRESADA: 4
      }
    },
    props: {
      titulo: String,
      cedula: Object,
      esConsultaPublica: {
        type: Boolean,
        default: false
      },
      mostrarObservacionesAbogado: {
        type: Boolean,
        default: false
      },
      conInformacionDeJurisdiccion: {
        type: Boolean,
        default: false
      },
      conDatosParaJuzgado: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      obtenerNombreCompleto: function(observacion) {
          const USUARIO_OBSERVACION = observacion.Usuario;
          if(USUARIO_OBSERVACION == null) {
            return 'Sin usuario';
          }
          const DATOS_NOMBRE = [USUARIO_OBSERVACION.Nombre, USUARIO_OBSERVACION.ApellidoPaterno, USUARIO_OBSERVACION.ApellidoMaterno];
          return DATOS_NOMBRE.join(' ');
      },
      obtenerMotivosDeRegreso: function() {
        this.motivosDeRegreso = (this.campoRequeridoEsValido(this.cedula.MotivosDeDevolucion)) ? this.cedula.MotivosDeDevolucion : this.motivosDeRegreso;
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
    },
    created() { debugger
    console.log('this.cedula::',this.cedula);
      if(this.cedula.ObservacionesDeAbogados != null && this.cedula.ObservacionesDeAbogados.length > 0)
          this.observacionesDeAbogado = this.cedula.ObservacionesDeAbogados;
      if(this.cedula.Resultado != null)
          this.resultado = this.cedula.Resultado.TipoResultado.Nombre;
      if(this.cedula.Expediente != null) {
        this.tipoDeDocumento = (this.cedula.Expediente.TipoDocumento != null) ? this.cedula.Expediente.TipoDocumento.Nombre : null;
        this.numeroDocumento = this.cedula.Expediente.NumeroDeDocumento;
      }
      if(this.cedula.Expediente != null) {
        // por area
        //this.juzgado = (this.cedula.Expediente.Juzgado != null) ? this.cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
        // por jurisdicccion
        if(this.conInformacionDeJurisdiccion)
          this.juzgado = (this.cedula.Jurisdiccion != null && this.cedula.Jurisdiccion.Area != null) ? this.cedula.Jurisdiccion.Area.Nombre : 'Sin juzgado';
        else
          this.juzgado = (this.cedula.Expediente.Juzgado != null) ? this.cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
      }

      if(this.conDatosParaJuzgado) {
        this.obtenerMotivosDeRegreso();
      }
    },
    computed: {
      mostrarMotivos() {
        return (this.cedula.Estatus.TipoEstatusId == this.ESTATUS_CEDULA_REGRESADA && this.conDatosParaJuzgado);
      }
    }
  }
</script>
<style scoped>
.contenedor-observaciones {
    background-color: #242425;
    max-height: 16em;
    overflow-y: auto;
    padding: 8px;
    border-radius: 4px;
}

#contenedor-observacion {
    margin-top: 1em;
    padding-right: 4px;
    max-height: 16em;
    overflow-y: auto;
}

.deshabilitado {
    pointer-events:auto;
    cursor: not-allowed;
    opacity: 0.5;
}

.tooltip-ps-cedula .form-control {
   background-color: #504f54 !important;
    border: none !important;
    color: #FFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CInfomacionBasicoDeCedula.vue